<app-page-tabs
  [tabs]="tabs"
  [activeTab]="activeTab()"
  (tabChange)="activeTab.set($event)"
></app-page-tabs>

<div class="tab-content p-3">
  @switch (activeTab()) {
    @case ('travel-advisories') {
      <app-travel-advisories></app-travel-advisories>
    }
    @case ('service-accounts') {
      <app-accounts></app-accounts>
    }
    @case ('vulnerability-scanners') {
      <app-vulnerability></app-vulnerability>
    }
    @case ('server-exceptions') {
      <app-server></app-server>
    }
    @case ('soc-bulletins') {
      <app-bulletin></app-bulletin>
    }
  }
</div>
